export const BS_COLOR_NAMES: string[] = [
  'magenta',
  'pink',
  'cyan',
  'azure',
  'primary',
  'indigo',
  'info',
  'lavender',
  'olive',
  'emerald',
  'success',
  'teal',
  'danger',
  'copper',
  'orange',
  'warning',
  'slate',
  'secondary',
  'dark',
  'white',
  'light',
];

export const BS_HEX: Record<string, string> = {
  // Warm → Cool → Neutrals (aliases interleaved with their base)
  magenta: '#ff00aa',
  pink: '#ff8acc',

  danger: '#ff5a5b', // alias of red

  copper: '#b87333',
  orange: '#fd7e14',

  warning: '#ffbd4a', // alias of yellow

  olive: '#6b8e23',
  emerald: '#10b981',

  success: '#0fc469', // alias of green

  teal: '#20c997',
  cyan: '#35b8e0',
  azure: '#0ea5e9',

  primary: '#2095fe', // alias of blue

  indigo: '#6610f2',
  info: '#5b69bc', // alias of purple
  lavender: '#b57edc',

  // Neutrals
  slate: '#475569',
  secondary: '#6c757d', // alias of gray
  dark: '#343a40',
  white: '#ffffff',
  light: '#f8f9fa',
};
